import { PLANS_INITIAL_STATE_LITERAL } from '../../utils/common-literals';
import getSessionInfo from '../session-Info';

const sessionInfo = getSessionInfo();
const { plans, discount } = {
  plans: sessionInfo?.staticPlansAndAddons?.plans || [],
  discount: sessionInfo?.discount || {},
};

export function getPlanById(selectedPlanId) {
  return (selectedPlanId && (plans.find(({ id }) => selectedPlanId === id) || {})) || {};
}

export function getUserBasedTotalAmount({ selectedPlanId, numberOfUsers = 1 } = {}) {
  const {
    price = '', access,
  } = getPlanById(selectedPlanId);
  if (price) {
    const planAmount = parseFloat(price).toFixed(2);
    return access === 'admin' ? planAmount : parseFloat(planAmount * numberOfUsers).toFixed(2);
  }
  return 0.00;
}

export function getDiscountAmount(totalAmount) {
  if (discount.percentage) {
    return parseFloat((discount.rate / 100) * totalAmount);
  }
  return parseFloat(discount.rate);
}

export function getFutureCredits(totalAmount) {
  let futureCredits;
  if (discount.oneTime === false) {
    futureCredits = {};
    const date = new Date();
    const arr = new Array(Number(discount.period));
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i < arr.length; i++) {
      date.setMonth(date.getMonth() + 1);
      const data = `${date.toString().split(' ')[1]} ${date.getFullYear()}`;
      futureCredits[data] = getDiscountAmount(totalAmount).toFixed(2);
    }
  }
  return futureCredits;
}

export function getTotalAfterDiscount(totalAmount) {
  let discountAmount = Number(getDiscountAmount(totalAmount).toFixed(2));
  discountAmount = (discountAmount > totalAmount) ? totalAmount : discountAmount;
  return (totalAmount - discountAmount);
}

export function plansInitailStateHelper(initialState) {
  const plansInitialState = localStorage.getItem(PLANS_INITIAL_STATE_LITERAL);
  if (plansInitialState) {
    localStorage.removeItem(PLANS_INITIAL_STATE_LITERAL);
    return JSON.parse(plansInitialState);
  }
  return initialState;
}

export function getTotalAfterDeduction(ftpEnabled, discountEnabled, totalAmount) {
  if (ftpEnabled) {
    return 0.00;
  } if (discountEnabled) {
    return getTotalAfterDiscount(totalAmount).toFixed(2);
  }
  return totalAmount;
}

export function getCreditAmount(totalAmount) {
  return (getDiscountAmount(totalAmount) - totalAmount).toFixed(2);
}
